import Shuffle from 'shufflejs'

const shuffle = { grids: [] }

shuffle.init = () => {
  const elements = document.querySelectorAll('.shuffle')
  if (!elements.length) return
  shuffle.grids = []
  elements.forEach(element => {
    const grid = new Shuffle(element, {
      itemSelector: '.col'
    })
    shuffle.grids = [...shuffle.grids, grid]
  })
}

shuffle.update = () => {
  if (!shuffle.grids.length) return
  shuffle.grids.forEach(grid => {
    grid.update()
  })
}

export default shuffle
